import React, { useRef } from 'react'
import { useAuth } from 'react-oidc-context'

import { FileInput } from '../../../components/FileInput/FileInput'
import { Tooltip } from '../../../components/Tooltip'
import { TooltipHandle } from '../../../components/Tooltip/Tooltip'
import { useSession } from '../../../hooks/storeHooks/useSessionState'
import { useFileUpload } from '../../../hooks/useFileUpload'
import { OidcUser } from '../../../types/oidcUser'
import { getOrganizationId } from '../../../utils/getOrganization'

interface IProps {
  avatar_id: string
  onTrackEvent?: () => void
}

export const UploadInput: React.FC<IProps> = ({ avatar_id, onTrackEvent }) => {
  const { user } = useAuth()
  const { setIsFileUploading, isFileUploading, dataChannel, socketId } =
    useSession()
  const tooltipRef = useRef<TooltipHandle>(null)

  const orgId = getOrganizationId(user as OidcUser)

  const { fileInputRef, isProcessing, handleFileChange } = useFileUpload({
    avatarId: avatar_id,
    organizationId: orgId,
    setIsFileUploading,
    isFileUploading,
    showToasts: true,
    dataChannel,
    socketId: socketId || '',
  })

  const handleTouchEnd = () => {
    tooltipRef.current?.closeWithDelay()
  }

  const tooltipText = isProcessing
    ? 'Processing'
    : isFileUploading
      ? 'Uploading'
      : 'Upload file'

  const handleLabelClick = () => {
    if (onTrackEvent) {
      onTrackEvent()
    }
  }

  return (
    <>
      <Tooltip content={tooltipText} anchor="#upload-file" />
      <div id="upload-file" onTouchEnd={handleTouchEnd}>
        <FileInput
          isFileUploading={isFileUploading}
          handleFileChange={handleFileChange}
          handleUploadClick={handleLabelClick}
          ref={fileInputRef}
        />
      </div>
    </>
  )
}
